const SideBarIcon = ({ color = "#333333" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
    >
      <rect
        x="3.60156"
        y="4.79688"
        width="2.4"
        height="1.2"
        rx="0.6"
        fill={color}
      />
      <rect
        x="3.60156"
        y="7.20312"
        width="2.4"
        height="1.2"
        rx="0.6"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.6 2.4H21.6V15.6H9.6V2.4ZM7.2 0H9.6H21.6C22.9255 0 24 1.07452 24 2.4V15.6C24 16.9255 22.9255 18 21.6 18H9.6H7.2H2.4C1.07452 18 0 16.9255 0 15.6V2.4C0 1.07452 1.07452 0 2.4 0H7.2ZM7.2 15.6H2.4V2.4H7.2V15.6Z"
        fill={color}
      />
    </svg>
  );
};

export default SideBarIcon;
